module.exports = __webpack_public_path__ + "static/img/hover-1.25c989bf.png";